module.exports = __webpack_public_path__ + "static/media/insect(18).14541c8f.PNG";